import sortBy from 'lodash/sortBy'

export default {
  groupName: state => payload => {
    return state.groupList[payload] ? state.groupList[payload] : payload
  },
  groupListValues: (state, getters) => payload => {
    return !payload ? payload : payload.map(group => {
      return { id: group, value: getters.groupName(group) }
    })
  },
  groupNames: (state, getters) => payload => {
    return !payload ? payload : payload.map(group => {
      return getters.groupName(group)
    }).sort()
  },
  getGroupList: state => sortBy(Object.keys(state.groupList).map(key => ({ id: key, value: state.groupList[key] })), 'value'),
  getGroupListNoAdmin: state => sortBy(Object.keys(state.groupList).map(key => ({ id: key, value: state.groupList[key] })), 'value').filter(item => {
    return item.value !== 'MRXASSIST_ADMIN'
  })
}
